export const convertFooterDataToAdaptedObject = (footerData, isLanguageTr) => {
  const {
    socialMediaAccounts,
    footerMenus,
    bitexenDescription,
    externalLogos,
    footerTextTR,
    footerTextEN,
    baseUrl
  } = footerData;

  const adaptedFooterMenus = footerMenus.map((footerMenuColumn) =>
    footerMenuColumn.map(({ titleTR, titleEN, links }) => ({
      title: isLanguageTr ? titleTR : titleEN,
      links: links.map(({ url, textTR, textEN }) => ({
        url,
        text: isLanguageTr ? textTR : textEN
      }))
    }))
  );

  return {
    socialMediaAccounts,
    footerMenus: adaptedFooterMenus,
    bitexenDescription,
    externalLogos,
    footerText: isLanguageTr ? footerTextTR : footerTextEN,
    baseUrl
  };
};
